module.exports = __webpack_public_path__ + "img/dynamicLogo8.1018bcda.png";